import React from "react";

import Header from "./Header";
import Footer from "./Footer";
export default () => {
  return (
      <>
        <Header/>
        <main>
            <div class="breadcrumb__area bg-color-2 p-relative" style={{backgroundImage:`url('assets/img/resources/page-title-1.jpg')`}}>
                <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="breadcrumb__wrapper p-relative">
                            <h2 class="breadcrumb__title">About Us</h2>
                            <div class="breadcrumb__menu">
                            <nav>
                                <ul>
                                    <li><span><a href="index.html">Home</a></span></li>
                                    <li><span>About</span></li>
                                </ul>
                            </nav>
                            </div>                
                        </div>
                    </div>
                </div>
                </div>
            </div>  
            <section class="success-section sec-padding">
                <div class="mkt-container">
                    <div class="row g-4">
                        <div class="col-lg-6">
                            <div class="left-box position-relative">
                                <div class="shape-1" style={{backgroundImage:`url('assets/img/shape/shape-5.png')`}}></div>
                                <span class="left-text">Ready For <br/>New Project</span>
                                <figure>
                                    <img src="assets/img/resources/success-1.png" alt=""/>
                                </figure>
                                <div class="circle-main">
                                    <div class="circle">
                                        <h1>10+</h1>
                                        <div class="round-text">
                                            <div class="text_1">
                                                <p class="text_2">Years of Experience in Real Estate Expansion</p>
                                            </div>
                                        </div>                        
                                    </div>
                                </div>
                            </div>                
                        </div>
                        <div class="col-lg-6">
                            <div class="right-box">
                                <h2>Solutions Navigating Success Together</h2>
                                <p class="right-box-text">At GRSpaces, we specialize in enabling retail and commercial real estate growth across India. With over two decades of experience in property scouting, franchise rollouts, lease negotiation, and post-deal management, we’re trusted partners for brands looking to scale with precision.

Our approach blends on-ground intelligence, legal due diligence, and market-driven strategy to ensure our clients don’t just expand—they expand smart.
                                </p>
                                <div class="row g-2">
                                    <div class="col-6">
                                        <div class="box-1">
                                            <div class="icon-box">
                                                <i class="far fa-check"></i>
                                                <h3>Our mission</h3>
                                            </div>                            
                                            <hr/>
                                            <p class="mission-vision-text">To be the most trusted commercial real estate partner for brands, delivering end-to-end solutions from location discovery to lease execution, and everything in between.</p>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="box-1">
                                            <div class="icon-box">
                                                <i class="far fa-check"></i>
                                                <h3>Our vision</h3>
                                            </div>                            
                                            <hr/>
                                            <p class="mission-vision-text">To redefine how businesses grow in India—by making expansion strategic, data-backed, and frictionless for every retail brand.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="btn-box">
                                    <a href="contact.html" class="theme-btn btn-style-one">
                                        <span class="txt">Read More </span>            
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="project-section position-relative">
                <div class="shape-1" style={{backgroundImage:`url('assets/img/shape/shape-6.png')`}}></div>
                <div class="container-fluid">
                    <div class="project-container text-center">
                        <div class="title-box text-center position-relative">
                            <div class="title-shape" style={{backgroundImage:`url('assets/img/shape/title-shape.png')`}}></div>
                            <h4 class="sec-sub-title">Our Latest project</h4>
                            <h2 class="sec-title">Take a look our Completed <br/>Projects</h2>                  
                        </div>
                        <div class="row g-4">
                            <div class="col-lg-6 col-md-12">
                                <div class="project-box position-relative">
                                    <figure class="image">
                                        <img src="assets/img/projects/project-1.jpg" alt=""/>
                                    </figure>
                                    <div class="content-box">
                                        <div class="text-left">
                                            <h6>Design, Development</h6>
                                            <h4><a href="projects.html">Marketing Webdesign</a> </h4>
                                        </div>
                                        <div class="text-right">
                                            <h2>01</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6">
                                <div class="project-box position-relative">
                                    <figure class="image">
                                        <img src="assets/img/projects/project-2.jpg" alt=""/>
                                    </figure>
                                    <div class="content-box">
                                        <div class="text-left">
                                            <h6>Design, Development</h6>
                                            <h4><a href="projects.html">Marketing Webdesign</a> </h4>
                                        </div>
                                        <div class="text-right">
                                            <h2>02</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6">
                                <div class="project-box position-relative">
                                    <figure class="image">
                                        <img src="assets/img/projects/project-3.jpg" alt=""/>
                                    </figure>
                                    <div class="content-box">
                                        <div class="text-left">
                                            <h6>Design, Development</h6>
                                            <h4><a href="projects.html">Marketing Webdesign</a> </h4>
                                        </div>
                                        <div class="text-right">
                                            <h2>03</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-12">
                                <div class="project-box position-relative">
                                    <figure class="image">
                                        <img src="assets/img/projects/project-4.jpg" alt=""/>
                                    </figure>
                                    <div class="content-box">
                                        <div class="text-left">
                                            <h6>Design, Development</h6>
                                            <h4><a href="projects.html">Marketing Webdesign</a> </h4>
                                        </div>
                                        <div class="text-right">
                                            <h2>04</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-12">
                                <div class="project-box position-relative">
                                    <figure class="image">
                                        <img src="assets/img/projects/project-5.jpg" alt=""/>
                                    </figure>
                                    <div class="content-box">
                                        <div class="text-left">
                                            <h6>Design, Development</h6>
                                            <h4><a href="projects.html">Marketing Webdesign</a> </h4>
                                        </div>
                                        <div class="text-right">
                                            <h2>05</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-12">
                                <div class="project-box position-relative">
                                    <figure class="image">
                                        <img src="assets/img/projects/project-6.jpg" alt=""/>
                                    </figure>
                                    <div class="content-box">
                                        <div class="text-left">
                                            <h6>Design, Development</h6>
                                            <h4><a href="projects.html">Marketing Webdesign</a> </h4>
                                        </div>
                                        <div class="text-right">
                                            <h2>06</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="work-showcase-section pt-60" style={{backgroundImage:`url('assets/img/shape/showcase-bg.png')`}}>
                <div class="mkt-container">
                    <div class="title-box position-relative">
                        <div class="title-shape" style={{backgroundImage:`url('assets/img/shape/title-shape.png')`}}></div>
                        <h4 class="sec-sub-title">Our work showcase</h4>
                        <h2 class="sec-title">Explore our best recently <br/>completed project</h2>                  
                    </div>
                    <div class="work-showcase-container">
                        
                        <div class="inner-box position-relative">
                            <div class="left-box">
                                <h1>01 <span>/</span></h1>
                                <h4><a href="services.html">Marketing We design</a> </h4>
                            </div>
                            <div class="right-box">
                            <p>Transforming ideas into user-friendly and visually<br/> appealing websites.</p>
                                <div class="btn-box">
                                    <a href="services.html"><i class="fat fa-arrow-right-long"></i></a>
                                </div>
                            </div>
                            <figure class="image z-1">
                                <img src="assets/img/resources/showcase-1.jpg" alt=""/>
                            </figure>
                        </div>
                        <div class="inner-box position-relative">
                            <div class="left-box">
                                <h1>02 <span>/</span></h1>
                                <h4><a href="services.html">Business Consulting</a> </h4>
                            </div>
                            <div class="right-box">
                            <p>Transforming ideas into user-friendly and visually<br/> appealing websites.</p>
                                <div class="btn-box">
                                    <a href="services.html"><i class="fat fa-arrow-right-long"></i></a>
                                </div>
                            </div>
                            <figure class="image z-1">
                                <img src="assets/img/resources/showcase-1.jpg" alt=""/>
                            </figure>
                        </div>
                        <div class="inner-box position-relative">
                            <div class="left-box">
                                <h1>03 <span>/</span></h1>
                                <h4><a href="services.html">Social Media Management</a> </h4>
                            </div>
                            <div class="right-box">
                            <p>Transforming ideas into user-friendly and visually<br/> appealing websites.</p>
                                <div class="btn-box">
                                    <a href="services.html"><i class="fat fa-arrow-right-long"></i></a>
                                </div>
                            </div>
                            <figure class="image z-1">
                                <img src="assets/img/resources/showcase-1.jpg" alt=""/>
                            </figure>
                        </div>
                    </div>
                </div>
            </section>
        </main>
        <Footer/>
      </>
  );
};
